export const cancel = 'Cancelar';
export const save = 'Guardar';
export const create = 'Crear';
export const addImages = 'Añadir imágenes';
export const title = 'Agregar nuevo código promocional';
